// redux/thunks/analyticsThunk.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

export const getAnalyticsData = createAsyncThunk(
  "analytics/getAnalyticsData",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("Access token not found");

      const response = await axios.get(`${BASE_URL}/myData/getAnalytics`, {
        headers: { token },
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Invalid response format");
      }

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch analytics");
    }
  }
);

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnalyticsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAnalyticsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default analyticsSlice.reducer;